import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class SortimentForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="name" value={this.props.values.name} label="Név"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(SortimentForm);
